export const bankAccountData = [
  { y: 5000, marker: { enabled: true } },
  5015.625,
  5029.8359375,
  5044.087139322916,
  5058.378719550998,
  5072.710792589725,
  5085.3925695712,
  5098.106050995128,
  5110.851316122616,
  5123.628444412922,
  5136.437515523955,
  5151.4187916108995,
  5166.443763086431,
  5181.512557395434,
  5196.625302354504,
  5213.947386695686,
  5231.327211318005,
  5248.7649686890645,
  5268.447837321649,
  5288.204516711605,
  5308.035283649273,
  5330.152097331145,
  5352.361064403359,
  5374.662568838373,
  5397.056996208533,
  5419.5447336927355,
  5442.126170083122,
  5464.801695791802,
  5486.43320250431,
  5508.15033393089,
  5529.9534290026995,
  5551.842827992502,
  5573.8188725199725,
  5593.559481026814,
  5611.039354405023,
  5628.573852387539,
  5644.990526123669,
  5661.455081824863,
  5677.9676591468515,
  5694.528398152696,
  5711.137439313975,
  5727.794923511974,
  5745.694282647949,
  5763.649577281224,
  5781.660982210228,
  5799.728672779635,
  5816.644548075243,
  5833.609761340462,
  5850.624456477704,
  5866.226121694978,
  5881.869391352831,
  5896.083909048601,
  5910.332778495468,
  5924.616082710166,
  5936.959032882479,
  5949.327697534317,
  5961.722130237514,
  5974.142384675509,
  5986.588514643583,
  5999.06057404909,
  6011.558616911692,
  6024.082697363591,
  6036.632869649766,
  6049.209188128203,
  6061.811707270137,
  6074.440481660283,
  6087.095565997075,
  6099.777015092902,
  6112.4848838743455,
  6125.219227382417,
  6137.9801007727965,
  6150.767559316073,
  6163.581658397981,
  6176.422453519644,
  6189.2900002978095,
  6202.1843544650965,
  6215.105571870232,
  6228.0537084782945,
  6241.028820370958,
  6254.030963746731,
  6267.060194921203,
  6280.116570327289,
  6293.200146515471,
  6306.310980154045,
  6319.449128029366,
  6332.6146470460935,
  6345.80759422744,
  6359.028026715414,
  6373.600799276637,
  6388.20696777498,
  6404.177485194417,
  6420.187928907403,
  6436.238398729672,
  6453.669877726231,
  6471.148566978406,
  6490.02275029876,
  6508.951983320465,
  6530.106077266257,
  6551.328922017372,
  6572.620741013929,
  6593.981758422224,
  6615.412199137096,
  6638.84178400904,
  6662.354348660739,
  6685.950186978912,
  6709.629593891129,
  6733.392865369493,
  6757.2402984343435,
  6781.172191157965,
  6805.188842668316,
  6829.290553152767,
  6853.47762386185,
  6877.750357113027,
  6903.5419209522015,
  6929.430203155773,
  6958.302829002255,
  6987.295757456431,
  7016.409489779166,
  7045.644529319912,
  7075.0013815254115,
  7095.636802221527,
  7113.3758942270815,
  7128.195427340054,
  7141.560793766317,
  7154.951220254629,
  7167.472384890075,
  7180.015461563633,
  7191.383819377776,
  7202.77017709179,
  7212.974101509337,
  7223.192481486475,
  7233.425337501914,
  7243.672690063376,
  7253.934559707633,
  7263.304225180588,
  7272.685993138113,
  7282.079879212583,
  7291.485899056566,
  7300.9040683428475,
  7310.334402764457,
  7319.776918034694,
  7329.231629887156,
  7338.69855407576,
  7348.177706374774,
  7357.669102578841,
  7367.172758503006,
  7376.688689982739,
  7386.216912873966,
  7395.757443053095,
  7405.310296417038,
  7414.875488883244,
  7424.453036389717,
  7434.042954895054,
  7443.64526037846,
  7453.259968839782,
  7462.887096299533,
  7472.52665879892,
  7482.178672399868,
  7491.843153185052,
  7501.520117257916,
  7511.209580742708,
  7520.9115597845,
  7530.626070549222,
  7539.09802487859,
  7546.6371229034685,
  7554.183760026372,
  7560.478913159727,
  7566.779312254027,
  7573.0849616809055,
  7579.39586581564,
  7585.712029037153,
  7592.0334557280175,
  7598.360150274458,
  7604.692117066353,
  7611.029360497241,
  7617.371884964322,
  7623.719694868459,
  7630.072794614182,
  7636.431188609694,
  7642.794881266868,
  7649.163877001258,
  7655.538180232093,
  7661.917795382286,
  7668.302726878438,
  7674.692979150836,
  7681.088556633462,
  7687.48946376399,
  7693.895704983794,
  7700.307284737947,
  7706.0825152015,
  7711.8620770879015,
  7716.681990886082,
  7721.504917130385,
  7726.330857703592,
  7731.159814489657,
  7735.991789373713,
  7740.826784242072,
  7744.697197634193,
  7748.5695462330095,
  7752.443831006126,
  7756.320052921629,
  7760.19821294809,
  7764.078312054564,
  7767.960351210591,
  7771.844331386196,
  7775.730253551889,
  7778.646152396971,
  7781.56314470412,
  7784.481230883383,
  7787.400411344965,
  7790.320686499219,
  7793.242056756656,
  7796.16452252794,
  7799.088084223888,
  7802.0127422554715,
  7804.938497033817,
  7807.214937428786,
  7809.492041785536,
  7811.769810297723,
  7814.04824315906,
  7816.3273405633145,
  7818.607102704312,
  7820.887529775934,
  7823.168621972119,
  7825.450379486861,
  7827.732802514211,
  7830.0158912482775,
  7832.299645883225,
  7834.584066613274,
  7836.869153632703,
  7839.154907135846,
  7841.441327317094,
  7843.0749609269515,
  7844.708934877144,
  7846.343249238577,
  7847.977904082169,
  7849.612899478852,
  7851.248235499577,
  7852.883912215307,
  7854.519929697019,
  7856.156288015705,
  7857.792987242376,
  7859.430027448051,
  7861.06740870377,
  7862.705131080583,
  7864.3431946495575,
  7865.981599481776,
  7867.620345648335,
  7869.259433220345,
  7870.898862268933,
  7872.538632865239,
  7874.1787450804195,
  7875.819198985645,
  7877.4599946521,
  7879.101132150986,
  7880.742611553517,
  7882.384432930924,
  7884.026596354452,
  7885.669101895359,
  7887.31194962492,
  7888.955139614425,
  7890.598671935179,
  7892.242546658498,
  7893.8867638557185,
  7895.5313235981885,
  7897.1762259572715,
  7898.821471004346,
  7900.467058810805,
  7902.112989448057,
  7903.759262987525,
  7905.405879500648,
  7907.052839058877,
  7908.7001417336805,
  7910.347787596542,
  7911.995776718958,
  7913.644109172441,
  7915.292785028519,
  7916.941804358733,
  7918.591167234641,
  7920.240873727815,
  7921.890923909841,
  7923.541317852322,
  7925.192055626875,
  7926.843137305131,
  7928.494562958736,
  7933.449872060585,
  7938.408278230623,
  7948.331288578412,
  7958.266702689135,
  7968.214536067497,
  7982.82292938362,
  8000.7842809747335,
  8018.786045606927,
  8036.828314209542,
  8058.259856380768,
  8079.748549331117,
  8101.294545462667,
  8122.897997583901,
  8146.589783410188,
  8170.350670278468,
  8194.180859733448,
  8218.08055390767,

  { y: 8242.049955523235, marker: { enabled: true } },
];

export const investmentPortfolioData = [
  { y: 5000, marker: { enabled: 'true' } },
  4916.644959624901,
  5114.613180515759,
  5449.33576452201,
  5325.605626465224,
  5691.586350612138,
  5656.420942953893,
  5677.259703047668,
  5595.207085178431,
  5954.67569679604,
  6926.282886168272,
  8430.580880437614,
  8615.524876269861,
  9294.08700182339,
  8988.017712946079,
  9023.183120604323,
  8559.520708517843,
  8620.734566293304,
  8581.661891117477,
  8638.968481375357,
  8193.539984370927,
  7994.269340974211,
  7520.187548840843,
  7508.465746288094,
  7332.638707996873,
  7036.988799166449,
  6895.0247460276105,
  7582.703829122166,
  7624.381349309715,
  7029.174264131283,
  6836.41573326387,
  6249.023183120603,
  5828.340713727533,
  6439.176868976295,
  7014.8476165668135,
  7116.436572023964,
  7064.3396717895275,
  7005.730659025787,
  7294.868455326907,
  6855.952070851783,
  6685.334722584005,
  6252.930450638186,
  5694.191195623859,
  5668.142745506642,
  5085.959885386818,
  5496.222974733003,
  5901.276374055743,
  5477.98905965095,
  5243.553008595987,
  5091.169575410263,
  5054.701745246158,
  5519.666579838499,
  5483.198749674394,
  5665.53790049492,
  5786.663193539984,
  6022.401667100807,
  5897.36910653816,
  6211.252930450637,
  6332.378223495701,
  6363.636363636363,
  6552.487626986193,
  6717.895285230527,
  6646.262047408179,
  6631.935399843708,
  6516.019796822088,
  6743.943735347746,
  6620.21359729096,
  6634.54024485543,
  6793.435790570459,
  6914.561083615525,
  7169.83589476426,
  7201.094034904922,
  7247.981245115914,
  7531.90935139359,
  7504.558478770512,
  7332.638707996873,
  7731.179994790309,
  7952.5918207866625,
  8216.983589476426,
  8149.257619171658,
  8450.117218025525,
  8127.116436572022,
  8404.532430320394,
  8651.992706433966,
  8899.452982547537,
  9218.546496483457,
  9417.817139880177,
  9430.841364938784,
  8899.452982547537,
  8843.44881479552,
  8861.682729877572,
  9034.904923157072,
  9182.078666319352,
  9493.019275853085,
  9537.64001041938,
  9783.79786402709,
  9941.390987236258,
  9837.197186767386,
  10023.443605105494,
  10407.65824433446,
  10638.187027871842,
  10565.25136754363,
  10429.799426934096,
  10230.528783537378,
  10315.186246418338,
  10407.65824433446,
  9818.963271685334,
  9718.676738734044,
  8788.747069549361,
  8930.711122688197,
  8714.50898671529,
  9032.300078145348,
  9208.127116436572,
  8414.951810367282,
  8288.616827298774,
  8485.28262568377,
  7535.8166189111735,
  6556.394894503776,
  6238.603803073716,
  6118.780932534512,
  5945.558739255013,
  5394.634019275853,
  5505.33993227403,
  6334.983068507423,
  6564.209429538942,
  6586.350612138577,
  6960.145871320655,
  7292.263610315185,
  7500.65121125293,
  7391.247720760613,
  7374.316228184422,
  7709.0388121906735,
  7589.215941651471,
  7567.074759051836,
  8160.979421724406,
  8136.233394113049,
  7675.17582703829,
  7525.397238864287,
  7845.793175306068,
  7706.433967178952,
  8015.108101067985,
  8158.374576712685,
  8003.386298515237,
  8433.185725449335,
  8555.61344100026,
  8622.036988799166,
  8546.496483459234,
  8687.15811409221,
  8572.54493357645,
  8309.45558739255,
  8020.317791091428,
  7399.0622557957795,
  7033.081531648866,
  7408.179213336805,
  7324.8241729617075,
  7404.271945819223,
  7685.595207085177,
  8004.688721021098,
  8075.019536337587,
  8024.225058609011,
  7727.272727272726,
  7862.724667882259,
  8159.6769992185455,
  8159.6769992185455,
  8276.895024746025,
  8188.330294347485,
  8243.032039593643,
  8313.362854910132,
  8499.609273248241,
  8689.762959103931,
  8913.779630112007,
  8866.892419901014,
  8985.412867934356,
  8683.250846574627,
  8809.585829643134,
  8685.855691586348,
  8899.452982547537,
  9179.47382130763,
  9253.711904141703,
  9257.619171659284,
  9132.586611096638,
  9353.99843709299,
  9381.34930971607,
  9337.066944516799,
  9619.692628288616,
  9740.81792133368,
  9779.890596509507,
  10044.28236519927,
  10102.89137796301,
  10237.040896066681,
  10403.750976816877,
  10436.3115394634,
  10953.373274290178,
  11480.854389163844,
  11799.947903099763,
  11651.47173743162,
  11806.460015629069,
  11423.547798905962,
  11529.044021880696,
  10850.481896327166,
  10494.92055222714,
  11254.232873144047,
  11643.657202396456,
  11143.52696014587,
  10565.25136754363,
  10444.126074498565,
  10665.537900494919,
  10739.77598332899,
  11010.67986454806,
  10743.683250846572,
  11054.962229747327,
  11091.430059911434,
  11088.825214899713,
  11060.171919770772,
  11325.866110966395,
  11605.88694972649,
  11588.955457150298,
  11953.63375879135,
  11977.077363896846,
  12036.988799166447,
  11943.214378744464,
  11857.254493357645,
  11776.504297994268,
  11725.709820265693,
  11927.585308674132,
  12229.747330033862,
  12135.972909611877,
  12198.489189893198,
  12395.154988278196,
  12224.537640010418,
  11905.444126074497,
  12026.569419119562,
  12283.146652774158,
  12091.690544412606,
  12236.259442563167,
  12361.29200312581,
  12327.429017973429,
  11736.12920031258,
  11835.113310758008,
  11095.337327429015,
  11777.80672050013,
  12055.2227142485,
  12280.541807762436,
  12556.655379004947,
  12018.754884084396,
  12408.179213336804,
  12573.58687158114,
  12451.159156030213,
  12771.555092471996,
  12853.607710341232,
  13150.560041677518,
  13330.294347486322,
  13309.455587392547,
  12478.510028653294,
  10966.397499348788,
  11911.9562386038,
  12247.981245115914,
  12418.598593383691,
  12406.876790830944,
  12839.281062776763,
  12797.603542589215,
  12557.957801510809,
  13602.50065121125,
  13820.005209690022,
  13831.727012242769,
  14034.904923157072,
  14751.237301380566,
  14946.600677259701,
  15001.30242250586,
  15433.706694451677,
  15613.441000260482,
  15942.95389424329,
  15595.207085178428,
  16117.478510028652,
  16008.075019536334,
  16383.172701224275,
  15681.16697056525,
  15253.972388642875,
  15540.505339932271,
  15188.851263349829,
  15014.326647564469,
  14146.913258661109,
  15333.42016150039,
  14963.532169835893,
  14037.509768168791,
  14511.59156030216,
  14993.487887470694,
  14297.994269340972,
  14869.757749413908,
  14796.822089085697,
  14821.568116697053,
  14802.031779109142,
  14924.459494660066,
  15195.363375879133,
  15476.686637145087,
  15308.674133889032,
  15037.770252669963,
  14606.668403230007,
  15332.117738994528,
  15936.441781713986,

  { y: 16249.023183120602, marker: { enabled: 'true' } },
];

export const globalStocksData = [
  { y: 5000, marker: { enabled: 'true' } },
  5283.85,
  5321.65,
  5637.2,
  5980.15,
  5845.85,
  6188.15,
  5945.6,
  6014.55,
  5908.4,
  6298.55,
  6760.5,
  7341.75,
  7091.95,
  7227.2,
  7774.9,
  7820.1,
  7490.35,
  7491.95,
  7533.05,
  8107.6,
  7734.85,
  7919,
  7243.5,
  6825.75,
  7024.95,
  6504.4,
  6323.2,
  6772.65,
  6995.9,
  6786.1,
  6479.35,
  5942.75,
  5405.9,
  5571.15,
  5936.85,
  6008.15,
  6026.4,
  5946.9,
  6158.35,
  5761.9,
  5570.35,
  4950.8,
  4567.4,
  4575.5,
  4042.2,
  4332.3,
  4546.4,
  4101.65,
  3888.4,
  3806.6,
  3749.5,
  3993.6,
  4007.8,
  4177.4,
  4349.35,
  4556.3,
  4322.75,
  4588.25,
  4518.5,
  4564.5,
  4709.9,
  4789.65,
  4812.45,
  4835.15,
  4793,
  4911.55,
  4802.65,
  4780.6,
  4767.8,
  4770.25,
  4807.5,
  4881.55,
  4976.5,
  5044.3,
  5053.95,
  4980.7,
  5303.9,
  5458.7,
  5631.95,
  5606.9,
  5869.6,
  5766.15,
  6056.5,
  6189.05,
  6281.6,
  6390.9,
  6437.7,
  6375.75,
  6044.7,
  6072.85,
  6124,
  6266.95,
  6410.1,
  6596.7,
  6510.65,
  6679.55,
  6859.6,
  6715.65,
  6789,
  6917.9,
  7219.5,
  7140.35,
  6890.35,
  6916.4,
  6947.5,
  7040.3,
  6658.6,
  6600.7,
  6021.35,
  5841.45,
  5545.6,
  5945.3,
  6054.45,
  5497.65,
  5417.3,
  5663.05,
  5232.2,
  4698.45,
  4394.6,
  4142.4,
  4100.95,
  3717.15,
  3826,
  4267.4,
  4362.05,
  4383.85,
  4705.8,
  4842.9,
  4945.8,
  4813.55,
  4926.2,
  5249.1,
  5195.4,
  5368.25,
  5752.55,
  5858.1,
  5745.9,
  5560.8,
  5653.55,
  5581.25,
  5682.4,
  5790.7,
  6052.25,
  6306.45,
  6311.85,
  6487.35,
  6254.75,
  6240.75,
  6313.35,
  6163.4,
  6107.4,
  5668.6,
  5560.1,
  5903.15,
  5970.65,
  6190.35,
  6448.65,
  6622.3,
  6741.3,
  6710.55,
  6570,
  6730.6,
  7026.65,
  7042.8,
  7093.1,
  6996.6,
  7063.8,
  7103.25,
  7252.75,
  7546.6,
  7867.15,
  7909.25,
  8056.1,
  7837.55,
  8078.45,
  7965.4,
  8150.25,
  8434.8,
  8575.65,
  8656.05,
  8519.2,
  8738.95,
  8774.95,
  8816.6,
  9143.45,
  9279.7,
  9346.45,
  9707.15,
  9851.15,
  9999.2,
  10255.45,
  10399.65,
  10952.2,
  11669.65,
  12004.5,
  11781.6,
  12093.35,
  11627.75,
  11940.55,
  10999.5,
  10639.1,
  11605.9,
  12084.35,
  11547.2,
  10901.95,
  10782.65,
  10986.35,
  11110.6,
  11505.65,
  11405.85,
  11813.15,
  11876.75,
  11838.35,
  11904.7,
  12485.55,
  12862.2,
  12859.25,
  13447.55,
  13512.05,
  13474.4,
  13337.1,
  13205,
  13084.05,
  12999.9,
  13372.15,
  13830.05,
  13811.9,
  13904.5,
  14113.45,
  13824.35,
  13419.75,
  13825.65,
  14413.3,
  14408.55,
  14830.5,
  15105.5,
  15222.1,
  14462.2,
  14644.4,
  13407.35,
  14400.9,
  14955.2,
  15375.85,
  15960.45,
  15139.65,
  15797.05,
  16242,
  16093.15,
  16609.95,
  16648.6,
  17322.85,
  17532,
  17655.15,
  16313.95,
  14181.15,
  15766.15,
  16284.65,
  16561.55,
  16488.1,
  17398.4,
  17138.85,
  16728.75,
  18380,
  18737.35,
  18687.7,
  19190.25,
  20489.7,
  20944.75,
  20930.9,
  21908.25,
  22307.9,
  22973.7,
  22438.55,
  23750.4,
  23891.3,
  24665.4,
  23702.95,
  23065.85,
  23938.1,
  23160.1,
  22842.5,
  21387.1,
  23675.55,
  23013.25,
  21435.5,
  22778.35,
  23395.75,
  21621.5,
  22756.35,
  22753.45,
  22912.4,
  22954.95,
  23551.85,
  24414.9,
  24976.85,
  24777.05,
  24312.7,
  23652.1,
  25072.8,
  25989.7,
  26753.2,
  { y: 28003.6, marker: { enabled: 'true' } },
];
